import locationSceneTemplate from './locationScene.html';
import './locationScene.scss';

export default angular
  .module('main.locations.edit.components.scene', [])

  .directive('editLocationScene', () => {
    return {
      restrict: 'E',
      template: locationSceneTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $filter,
                   $log,
                   utils,
                   config,
                   EditLocationDataProvider,
                   ToastsService,
                   PermissionsService) => {
        const $t = $filter('translate');
        $scope.dataProvider = EditLocationDataProvider.instance;

        const locationScenes = config.getConfigByKey('locationScenes');

        $scope.occupancyTypes = config.getConfigByKey('locationOccupancyTypes');
        $scope.scenesToSelect = angular.copy(locationScenes);

        angular.extend($scope, {
          onChangeSceneButtonClick: onChangeSceneButtonClick,
          onChangeOccupancyButtonClick: onChangeOccupancyButtonClick,
          onGoToScenesHistoryButtonClick: onGoToScenesHistoryButtonClick,
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.locationResource.init(),
            $scope.dataProvider.locationOccupancyResource.init(),
          ])
            .then(() => {
              $scope.loading = false;

              $scope.$watchGroup([
                'dataProvider.locationResource.value.event',
                'dataProvider.occupancyLocationStateResource.value.status',
              ], () => {
                initViewModel();
              });
            }, () => {
              $scope.loading = false;
            });

          $scope.$on('$destroy', () => {
            $('#change-location-scene-modal').remove();
            $('#change-location-occupancy-modal').remove();
          });
        }

        function initViewModel() {
          $scope.canChangeScene = !!PermissionsService.canIChangeLocationScene($scope.dataProvider.locationResource.value);

          const mode = $scope.dataProvider.locationResource.value?.event;
          const occupancy = $scope.dataProvider.locationOccupancyResource.value;

          $scope.scene = {
            name: $t('locations.scenes.defaultMode'),
            color: 'grey',
            icon: 'home'
          };

          if (mode) {
            // Search for corresponding scene
            let simplifiedEvent = mode.split('.')[0].toLowerCase();
            let detectedScene = locationScenes.find(el => el.id.toLowerCase() === simplifiedEvent) || {};
            if (detectedScene) {
              $scope.scene = Object.assign($scope.scene, detectedScene);
            }
            $scope.scene.event = mode;
          }

          // Identify occupancy
          if (occupancy) {
            const dateFormat = $t('datetime.mdyHM12');
            const occupancyType = $scope.occupancyTypes.find(el => el.value === occupancy.status);
            $scope.occupancy = {
              ...occupancy,
              name: occupancyType ? $t(occupancyType.name) : occupancy.status,
              startDateFormatted: $filter('date')(occupancy.startDate, dateFormat),
            };

            const selectedOccupancy = $scope.occupancyTypes.find(el => el.value === occupancy.status);
            $scope.selectedOccupancyId = selectedOccupancy ? selectedOccupancy.id : undefined;
          }
        }

        function onChangeSceneButtonClick() {
          if (!$scope.canChangeScene || !$scope.dataProvider.locationResource.value || $scope.loading) {
            return;
          }

          if ($scope.scene.id) {
            $scope.selectedSceneId = $scope.scene.id;
            $scope.selectedSceneObj = $scope.scene;
          } else {
            $scope.selectedSceneId = undefined;
            $scope.selectedSceneObj = undefined;
          }

          $('#change-location-scene-modal')
            .modal({
              autofocus: false,
              closable: false,
              detachable: true,
              onApprove: () => {
                $scope.$applyAsync(() => {
                  $('#change-location-scene-modal').modal('hide');
                  changeLocationScene();
                });
              }
            })
            .modal('show');
        }

        function onChangeOccupancyButtonClick() {
          if (!$scope.occupancy) {
            return;
          }

          $('#change-location-occupancy-modal')
            .modal({
              autofocus: false,
              closable: false,
              detachable: true,
              onApprove: () => {
                $scope.$applyAsync(() => {
                  $('#change-location-occupancy-modal').modal('hide');
                  changeLocationOccupancy();
                });
              }
            })
            .modal('show');
        }

        function onGoToScenesHistoryButtonClick() {
          if (this.loading) {
            return;
          }
          $scope.dataProvider.activeTab = 'scenes';
        }

        function changeLocationScene() {
          if (!$scope.canChangeScene || !$scope.dataProvider.locationResource.value || $scope.loading || !$scope.selectedSceneId) {
            return;
          }

          $scope.loading = true;
          $scope.dataProvider.changeLocationScene($scope.selectedSceneId.toUpperCase())
            .then(() => {
              $scope.loading = false;
              ToastsService.success(null, $t('locations.edit.scene.changeSceneModal.success', { scene: $t($scope.selectedSceneObj.name) }));
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function changeLocationOccupancy() {
          if (!$scope.dataProvider.locationResource.value || $scope.loading || !$scope.selectedOccupancyObj) {
            return;
          }

          $scope.loading = true;
          $scope.dataProvider.changeLocationOccupancy($scope.selectedOccupancyObj)
            .then(() => {
              $scope.loading = false;
              $scope.occupancy = angular.copy($scope.dataProvider.locationOccupancyResource.value);
              ToastsService.success(null, $t('locations.edit.scene.changeOccupancyModal.success', { occupancy: $t($scope.occupancy.name) }));
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }
      }
    };
  })
  .name;
